module.exports = __webpack_public_path__ + "static/img/index_bottom.0467cfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_bottom.png
// module id = Dijg
// module chunks = 1